<template>
  <a @click="openPlace" class="block bg-white mr-4 border border-section_border rounded p-2 w-48 overflow-hidden">
    <img v-lazy="duration.place.image" class="w-full h-24" />
    <h2 class="mt-2 text-sm font-bold truncate">{{ duration.place.name }}</h2>
    <p class="text-btn_secondary text-xs">
      {{ $t('tour_duration_label', { label: label, duration: duration.amount }) }}{{ getStayTime(duration.stayTime) }}
    </p>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    duration: {
      type: Object
    }
  },
  methods: {
    openPlace: function () {
      this.$gtag.event("POI詳細表示", {
        poi_id: this.duration.place.id,
        poi_name: this.duration.place.name
      });
      this.$store.dispatch('drawer/openPlace', { place: this.duration.place, full: true })
    },
    getStayTime: function (stayTime) {
      if (stayTime !== undefined && stayTime > 0) {
        return '(滞在' + stayTime + '分)'
      }
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
    }),
    label: function () {
      if (this.from.route) {
        return this.$t('tour_duration_before_label')
      } else {
        return this.$t('tour_duration_current_label')
      }
    }
  }
}
</script>
